import React from "react";
import Navbar from '../../components/Navbar';
import Footer from '../../components/Footer';
import BreadCrumb from '../../components/BreadCrumb';

const InformationTechnology = () => {
    return (
        <div>
            <Navbar />
                <div class="container">
                    <BreadCrumb 
                        active_page="Information Technology" 
                        prev_sub_page={{
                            'link':'/services',
                            'text':'Services'
                        }}
                        sub_page={{
                            'link':'/services/business-domains',
                            'text':'Business Domains'
                        }} 
                    />
                    <div class="inner-container">
                        <h2>Information Technology</h2>
                        <h3>Right Sized</h3>
                        <p>It’s your idea and we help you do more of it. We speak your language and turn your ideas into ground breaking business solutions.</p>
                        <h3>Data Driven</h3>
                        <p>The best strategies are built using data and you cannot manage what you cannot measure. We help structure the data story using interactive custom built dashboards for informed decision making.</p>
                        <h3>Our Services</h3>
                        <h3>Product Development</h3>
                        <p>We develop your ideas and use technologies that fit your business. Applications that conceptualize, define, realize, and support your business transformation programs.</p>
                        <h3>Web Design</h3>
                        <p>Make sure it makes the right impression. Engage your audience with interactive websites. We develop customizable, scintillating, SEO friendly websites that meets your evolving business needs.</p>
                        <h3>Web Development</h3>
                        <p>We are an expertise in all kinds of web development solutions ranging from static web pages to complex web based social network services</p>
                        <h3>App Modernization</h3>
                        <p>It’s not just techology but the people behind the technology that makes the difference. Our technology roadmaps will enable seamless modernization of applications and systems.</p>
                        <h3>Technology Consulting</h3>
                        <p>We just don’t deploy the technology at your organization. We focus on embedding it into your business process.</p>
                        <h3>Efficient Can Be Simple Too</h3>
                        <ul>
                            <li>Powerful Tools</li>
                            <li>Bespoke Workflows</li>
                            <li>Intelligent Automation</li>
                            <li>Realtime Reporting</li>
                        </ul>
                    </div>
                </div>
            <Footer />
        </div>
    );
};

export default InformationTechnology;